import React from 'react';

import styles from './MainButtonTransparentBackground.module.scss';

const MainButtonTransparentBackground = ({text, width, type, condition, onClick}) => {
    return (
        <button
            onClick={onClick && onClick}
            disabled={condition}
            type={type}
            style={{width}}
            className={styles.button}
        >
            {text}
        </button>
    );
};

export default MainButtonTransparentBackground;